<template>
  <div class="fotter">
    <p>Copyright © 2026 sh-million.com All Rights Reserved</p>
    <a href="https://beian.miit.gov.cn/"
      >版权所有·上海米仑 沪ICP备2015606号-1</a
    >
    <p>电话：021-56523831</p>
    <p>地址：上海市宝山区高境镇共和新路4727号新陆国际商务大厦805室</p>
  </div>
</template>

<script>
export default {
  name: "mb-fotter",
};
</script>

<style scoped lang='less'>
.fotter {
  background: #054183;
  position: relative;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  // height: 1.6rem;
  padding: 0.3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    margin: 0.08rem 0;
    color: #fcfdfd;
    font-size: 0.12rem;
    line-height: 1;
  }
  a {
    margin: 0.08rem 0;
    color: #fcfdfd;
    font-size: 0.12rem;
    line-height: 1;
    &:hover {
      margin: 0.08rem 0;
      color: #fcfdfd;
      font-size: 0.12rem;
      line-height: 1;
    }
  }
}
</style>
